import { RenderWithBuilder } from "@faire/builder-core/BuilderComponents/RenderWithBuilder";
import { SDUISiteBannerRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/SiteBanner/SDUISiteBannerRenderer";
import { SDUIRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/SDUIRenderer/SDUIRenderer";
import { SDUIColumnSectionRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/SectionRenderers/ColumnSection/SDUIColumnSectionRenderer";
import { SDUIRotatingSectionRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/SectionRenderers/RotatingSection/SDUIRotatingSectionRenderer";
import {
  ComponentRenderMap,
  SectionRenderMap,
} from "@faire/deprecated-retailer-visitor-shared/components/SDUI/types";
import { useConductorComponent } from "@faire/deprecated-retailer-visitor-shared/features/Conductor/useConductorComponent";
import { ConductorSurface } from "@faire/web-api--source/indigofair/data/ConductorSurface";
import { IViewLayout } from "@faire/web-api--source/indigofair/data/IViewLayout";
import React from "react";

const bannerComponentRenderers: ComponentRenderMap = {
  site_banner_component: {
    active: SDUISiteBannerRenderer,
  },
};

const bannerSectionRenderers: SectionRenderMap = {
  column_section: SDUIColumnSectionRenderer,
  rotating_section: SDUIRotatingSectionRenderer,
};

export const ConductorBanner: React.FC<{
  overrideViewLayout?: IViewLayout;
}> = ({ overrideViewLayout }) => {
  const { conductorBuilderModelName, conductorSduiViewLayout } =
    useConductorComponent({
      surface: ConductorSurface.SITE_WIDE_TOP_BANNER,
    });

  const viewLayout = overrideViewLayout ?? conductorSduiViewLayout;

  if (conductorBuilderModelName) {
    return <RenderWithBuilder modelName={conductorBuilderModelName} />;
  }

  if (!viewLayout?.content?.length) {
    return null;
  }

  return (
    <SDUIRenderer
      viewLayout={viewLayout}
      componentRenderers={bannerComponentRenderers}
      sectionRenderers={bannerSectionRenderers}
      UPLTprops={{
        shouldRenderBelowTheFold: false,
      }}
    />
  );
};
